// Datos compartidos del módulo Investigación

// Semillas demo eliminadas: la biblioteca se alimenta del backend (research_items)
// + investigaciones propias. El array viejo queda abajo, sin exportar/usar.
export const RESEARCH_ITEMS = [];
// eslint-disable-next-line no-unused-vars
const _RESEARCH_SEED_UNUSED = [
  {
    id: 1,
    title: 'Análisis de Intención de Voto por Región',
    type: 'Informe',
    excerpt: 'Estudio detallado sobre la intención de voto en las principales regiones, con segmentación demográfica y tendencias históricas.',
    date: '2025-08-25',
    author: 'Equipo de Investigación',
    category: 'electoral',
    tags: ['intención', 'demografía', 'tendencias'],
    pages: 28,
    body: `## Resumen ejecutivo

La intención de voto del candidato se ubica en **24.89%** combinando LLA + PSN, con
un piso firme en zona portuaria (68%) y crecimiento sostenido entre votantes 18-34.

## Hallazgos principales

- **Zona portuaria** concentra el voto duro (68% adhesión declarada)
- **Centro y sur** son las dos regiones con mayor margen de crecimiento
- **Indecisos**: 18% del total, con sesgo joven y femenino
- Brecha generacional clara: 32% en 25-34 vs 6% en 55+

## Metodología

Encuesta presencial (n=820, error ±3.4%) + telefónica (n=410), ponderada por
distrito y nivel socioeconómico. Trabajo de campo del 18 al 22 de agosto.

## Recomendaciones

1. Concentrar inversión digital y eventos en centro y sur
2. Diseñar mensajes específicos para 25-34 años (foco en empleo y vivienda)
3. Capitalizar fortaleza portuaria con anuncio de plan económico local`,
  },
  {
    id: 2,
    title: 'Percepción de Candidatos en Redes Sociales',
    type: 'Dashboard',
    excerpt: 'Análisis de sentimiento y percepción de los principales candidatos en plataformas de redes sociales durante el último trimestre.',
    date: '2025-08-20',
    author: 'Departamento Digital',
    category: 'digital',
    tags: ['sentimiento', 'redes', 'percepción'],
    pages: 14,
    body: `## Sentimiento por candidato (últimos 90 días)

| Candidato | Positivo | Negativo | Volumen |
| --- | --- | --- | --- |
| Federico Chouhy | 62% | 18% | 4.2K menciones |
| Manuel Passaglia | 38% | 42% | 9.1K menciones |
| Cecilia Comerio | 51% | 24% | 3.6K menciones |
| Juntos por el Cambio | 44% | 31% | 2.1K menciones |

## Insights clave

- El candidato propio tiene la **mejor relación señal/ruido** (positivo - negativo)
- Passaglia concentra el mayor volumen pero también la mayor negatividad
- IG y X muestran sesgos opuestos: IG favorece propuestas, X favorece confrontación

## Topics dominantes

Seguridad (38%), Empleo (24%), Movilidad (16%), Transparencia (12%), Otros (10%).`,
  },
  {
    id: 3,
    title: 'Efectividad de Mensajes por Segmento',
    type: 'Estudio',
    excerpt: 'Evaluación de la resonancia y efectividad de los mensajes de campaña en diferentes segmentos demográficos y geográficos.',
    date: '2025-08-18',
    author: 'Equipo de Comunicación',
    category: 'messaging',
    tags: ['mensajes', 'segmentación'],
    pages: 22,
    body: `## Mensajes evaluados (A/B)

1. **"Anti-casta"** vs **"Renovación responsable"**
2. **"Plan San Nicolás Libertario"** vs **"Hechos no promesas"**

## Resultados por segmento

- **18-29**: prefiere "Renovación responsable" (+11 pts)
- **30-49**: empate técnico
- **50+**: "Hechos no promesas" levemente arriba (+4 pts)

## Recomendación

Comunicación diferenciada por canal: TikTok/IG con renovación, gráfica callejera
con hechos. Evitar "anti-casta" puro en segmentos mayores.`,
  },
  {
    id: 4,
    title: 'Análisis de Temas Prioritarios por Región',
    type: 'Informe',
    excerpt: 'Identificación de los temas más relevantes para los votantes en cada región, basado en encuestas y análisis de medios.',
    date: '2025-08-15',
    author: 'Equipo de Estrategia',
    category: 'electoral',
    tags: ['temas', 'región', 'encuestas'],
    pages: 18,
    body: `## Top 3 preocupaciones por zona

- **Zona portuaria**: empleo, infraestructura, seguridad
- **Centro**: tránsito, comercio, recolección
- **Sur**: agua/cloacas, alumbrado, salud
- **Norte**: vivienda, espacio público, transporte
- **Periferia**: seguridad, conectividad, escuelas

## Conclusiones

No existe un tema único transversal. **Vivienda** y **seguridad** son los dos
ítems con mayor peso agregado. La estrategia territorial debe adaptar mensaje
zona por zona.`,
  },
  {
    id: 5,
    title: 'Impacto de Eventos de Campaña',
    type: 'Dashboard',
    excerpt: 'Medición del impacto y alcance de los eventos de campaña realizados en el último mes, con métricas de asistencia y engagement.',
    date: '2025-08-12',
    author: 'Equipo de Eventos',
    category: 'field',
    tags: ['eventos', 'engagement'],
    pages: 9,
    body: `## Resumen del mes

- 12 eventos realizados
- Asistencia total: ~4.300 personas
- Cobertura mediática: 38 notas (28 positivas, 7 neutras, 3 negativas)

## Top 3 eventos por engagement

1. Lanzamiento de campaña — 1.200 asistentes
2. Foro económico portuario — 580 asistentes
3. Recorrida en barrio Don Bosco — 420 asistentes

## Aprendizajes

Los eventos sectoriales (gremios, cámaras) generan menos volumen pero más
profundidad. Mantener un mix 1:2 (sectoriales:masivos).`,
  },
  {
    id: 6,
    title: 'Análisis Comparativo de Propuestas',
    type: 'Estudio',
    excerpt: 'Comparación detallada de las propuestas de política pública entre los principales candidatos y su recepción en diferentes audiencias.',
    date: '2025-08-10',
    author: 'Equipo de Políticas',
    category: 'policy',
    tags: ['propuestas', 'comparativa'],
    pages: 31,
    body: `## Mapa de propuestas

| Tema | LLA (Chouhy) | HECHOS | UxP | JxC |
| --- | --- | --- | --- | --- |
| Seguridad | tecnología + vecinal | tecnología avanzada | guardia urbana | cámaras |
| Movilidad | reordenar tránsito | master plan costero | colectivos eléctricos | bicis |
| Transparencia | portal abierto | declaraciones | auditorías | DDJJ |

## Brechas detectadas

- Ningún candidato tiene propuesta detallada de **salud pública municipal**
- LLA carece de propuesta concreta en **vivienda**
- Espacio para diferenciación en **digitalización del Estado local**`,
  },
  {
    id: 7,
    title: 'Mapeo de Influencers Locales',
    type: 'Dashboard',
    excerpt: 'Identificación de voces clave en el discurso público local y su grado de influencia sobre distintos segmentos.',
    date: '2025-08-05',
    author: 'Departamento Digital',
    category: 'digital',
    tags: ['influencia', 'mapeo'],
    pages: 12,
    body: `## Voces de mayor influencia local

1. **@FedePeriodista** — alcance 65K, sesgo neutral-favorable
2. **Radio Norte (live X)** — 28K, foco en problemas barriales
3. **@MovimientoSN** — 42K, militante UxP
4. **@PortuarioSN** — 19K, gremio, neutral

## Recomendación

Foco en **micro-influencers de barrio** (5-15K) que tienen mayor tasa de conversión
que las cuentas masivas. Estrategia de outreach con propuestas concretas.`,
  },
  {
    id: 8,
    title: 'Encuesta CABA · Movilidad y Seguridad',
    type: 'Encuesta',
    excerpt: 'Resultados de encuesta cara a cara sobre prioridades en movilidad y seguridad en San Nicolás.',
    date: '2025-07-28',
    author: 'Equipo de Investigación',
    category: 'field',
    tags: ['encuesta', 'seguridad', 'movilidad'],
    pages: 16,
    body: `## Resultados (n=620)

### Movilidad
- 41% considera que el tránsito empeoró en los últimos 12 meses
- 28% usa transporte público regularmente
- 18% pediría más ciclovías

### Seguridad
- 67% identifica la zona sur como más insegura
- 54% cree que hay menos presencia policial que el año pasado
- 38% dejó de salir de noche

## Conclusiones

La inseguridad pesa más que la movilidad en la agenda. Una propuesta integral
(seguridad + iluminación + transporte nocturno) puede capturar varios temas.`,
  },
  {
    id: 9,
    title: 'Riesgos Reputacionales · Q3',
    type: 'Informe',
    excerpt: 'Identificación de riesgos reputacionales por sector y plan de mitigación recomendado.',
    date: '2025-07-22',
    author: 'Equipo de Estrategia',
    category: 'electoral',
    tags: ['reputación', 'riesgo'],
    pages: 11,
    body: `## Riesgos identificados

1. **Falta de plan detallado** — vulnerabilidad principal del candidato
2. **Asociación con LLA nacional** — fricción con votantes moderados
3. **Cobertura adversa local** sobre intereses empresariales

## Plan de mitigación

- Lanzamiento de "Plan San Nicolás" en agosto (ataca riesgo #1)
- Campaña narrativa "yo te conozco, no a Milei" (ataca riesgo #2)
- Transparencia activa sobre patrimonio y actividades empresariales (riesgo #3)`,
  },
];

export const CATEGORY_META = {
  electoral: { label: 'Electoral', color: '#00B4D8' },
  digital: { label: 'Digital', color: '#06D6A0' },
  messaging: { label: 'Mensajería', color: '#FFD166' },
  field: { label: 'Terreno', color: '#A4B0C2' },
  policy: { label: 'Políticas', color: '#7C8AA0' },
};

/* ============================================================
   Red de contactos · 14 clusters · ~60 nodos
   Posiciones x/y se calculan de forma determinística desde el cluster
   en computeNetworkLayout(). viewBox 0-100.
   ============================================================ */

export const CLUSTER_META = {
  core:        { label: 'Candidato',    color: '#00B4D8' },
  team:        { label: 'Equipo',       color: '#06D6A0' },
  allies:      { label: 'Aliados',      color: '#FFD166' },
  opp:         { label: 'Oposición',    color: '#EF476F' },
  media:       { label: 'Medios',       color: '#A4B0C2' },
  press:       { label: 'Prensa nac.',  color: '#7C8AA0' },
  civil:       { label: 'Sociedad civil', color: '#9CA8B8' },
  union:       { label: 'Gremios',      color: '#FFB76A' },
  business:    { label: 'Empresariado', color: '#C0B6F0' },
  academia:    { label: 'Academia',     color: '#86E1E5' },
  government:  { label: 'Gobierno',     color: '#FF9FB1' },
  religion:    { label: 'Religiosos',   color: '#D9C9A3' },
  influencers: { label: 'Influencers',  color: '#7BC4FF' },
  donors:      { label: 'Mecenas',      color: '#FFD78B' },
};

export const NETWORK_NODES = [
  /* core */
  { id: 'fch', label: 'Federico Chouhy', role: 'Candidato a Concejal', cluster: 'core', weight: 38 },

  /* team — 8 */
  { id: 'team-jefe',     label: 'Jefe de campaña',     role: 'Equipo · estrategia', cluster: 'team', weight: 22 },
  { id: 'team-comm',     label: 'Dir. Comunicación',   role: 'Equipo · prensa',     cluster: 'team', weight: 22 },
  { id: 'team-data',     label: 'Lead Data & Analytics', role: 'Equipo · data',     cluster: 'team', weight: 18 },
  { id: 'team-terr',     label: 'Lead Territorio',     role: 'Equipo · terreno',    cluster: 'team', weight: 20 },
  { id: 'team-prensa',   label: 'Lead Prensa',         role: 'Equipo · vocería',    cluster: 'team', weight: 16 },
  { id: 'team-digital',  label: 'Lead Digital',        role: 'Equipo · redes',      cluster: 'team', weight: 18 },
  { id: 'team-fund',     label: 'Lead Fundraising',    role: 'Equipo · finanzas',   cluster: 'team', weight: 14 },
  { id: 'team-legal',    label: 'Asesor Legal',        role: 'Equipo · legal',      cluster: 'team', weight: 12 },

  /* allies — 7 */
  { id: 'lla-nac',       label: 'LLA Nacional',         role: 'Mesa nacional',         cluster: 'allies', weight: 30 },
  { id: 'lla-prov',      label: 'LLA Provincia BA',     role: 'Mesa provincial',       cluster: 'allies', weight: 26 },
  { id: 'lla-sn',        label: 'LLA San Nicolás base', role: 'Estructura local',      cluster: 'allies', weight: 22 },
  { id: 'concejal-1',    label: 'Concejal aliado',      role: 'Bloque',                cluster: 'allies', weight: 14 },
  { id: 'diputada-1',    label: 'Dip. Provincial aliada', role: 'Legislatura BA',      cluster: 'allies', weight: 16 },
  { id: 'int-ramallo',   label: 'Intendencia Ramallo',  role: 'Aliado regional',       cluster: 'allies', weight: 14 },
  { id: 'pro-local',     label: 'Sector PRO disidente', role: 'Diálogo táctico',       cluster: 'allies', weight: 12 },

  /* opp — 6 */
  { id: 'm-passaglia',   label: 'Manuel Passaglia',     role: 'HECHOS · Líder',     cluster: 'opp', weight: 26 },
  { id: 's-passaglia',   label: 'Santiago Passaglia',   role: 'HECHOS · Hermano',   cluster: 'opp', weight: 18 },
  { id: 'comerio',       label: 'Cecilia Comerio',      role: 'UxP · Referente',    cluster: 'opp', weight: 20 },
  { id: 'jxc-sn',        label: 'JxC San Nicolás',      role: 'Liderazgo fragmentado', cluster: 'opp', weight: 14 },
  { id: 'uxp-prov',      label: 'UxP Provincia',        role: 'Aparato partidario', cluster: 'opp', weight: 18 },
  { id: 'otro-precand',  label: 'Otros precandidatos',  role: 'Espacios menores',   cluster: 'opp', weight: 8 },

  /* media local — 6 */
  { id: 'm-norte',       label: 'Diario El Norte',       role: 'Diario local',  cluster: 'media', weight: 20 },
  { id: 'm-opinando',    label: 'Opinando San Nicolás',  role: 'Portal local',  cluster: 'media', weight: 18 },
  { id: 'm-op-online',   label: 'La Opinión Online',     role: 'Portal local',  cluster: 'media', weight: 16 },
  { id: 'm-prensalibre', label: 'Prensa Libre SN',       role: 'Diario local',  cluster: 'media', weight: 14 },
  { id: 'm-elnuevomundo',label: 'Radio Nuevo Mundo',     role: 'Radio AM',      cluster: 'media', weight: 14 },
  { id: 'm-radioz',      label: 'Radio FM Zonal',        role: 'Radio FM',      cluster: 'media', weight: 10 },

  /* press national — 4 */
  { id: 'p-clarin',      label: 'Clarín',     role: 'Diario nacional',  cluster: 'press', weight: 18 },
  { id: 'p-lanacion',    label: 'La Nación',  role: 'Diario nacional',  cluster: 'press', weight: 16 },
  { id: 'p-infobae',     label: 'Infobae',    role: 'Portal nacional',  cluster: 'press', weight: 16 },
  { id: 'p-pagina12',    label: 'Página/12',  role: 'Diario nacional',  cluster: 'press', weight: 12 },

  /* periodistas individuales (van en media o press según pertenencia) */
  { id: 'periodista-1',  label: 'Fede Periodista',  role: 'Periodista clave',     cluster: 'media', weight: 14 },
  { id: 'periodista-2',  label: 'Cris Editora',     role: 'Editora de portal',    cluster: 'media', weight: 12 },
  { id: 'periodista-3',  label: 'Hernán Cronista',  role: 'Cronista político',    cluster: 'press', weight: 10 },

  /* civil — 4 */
  { id: 'civ-camara',    label: 'Cámara empresaria',  role: 'Asociación local',     cluster: 'civil', weight: 16 },
  { id: 'civ-comercio',  label: 'Centro de comercio', role: 'Asociación comercial', cluster: 'civil', weight: 14 },
  { id: 'civ-vecinal',   label: 'Federación vecinal', role: 'Sociedades de fomento', cluster: 'civil', weight: 12 },
  { id: 'civ-foro-edu',  label: 'Foro educativo SN',  role: 'ONG educación',        cluster: 'civil', weight: 10 },

  /* union — 4 */
  { id: 'u-portuario',   label: 'Gremio Portuario',  role: 'Sindicato fuerte',  cluster: 'union', weight: 22 },
  { id: 'u-uocra',       label: 'UOCRA SN',          role: 'Construcción',      cluster: 'union', weight: 16 },
  { id: 'u-docente',     label: 'Gremio Docente',    role: 'Educación',         cluster: 'union', weight: 12 },
  { id: 'u-metalurgico', label: 'Metalúrgicos',      role: 'Industria',         cluster: 'union', weight: 14 },

  /* business — 5 */
  { id: 'b-sidersa',     label: 'SIDERSA',         role: 'Industria pesada',    cluster: 'business', weight: 22 },
  { id: 'b-moviport',    label: 'Grupo MoviPort',  role: 'Logística (propio)',  cluster: 'business', weight: 24 },
  { id: 'b-pymes',       label: 'Red PyMEs',       role: 'Comercio local',      cluster: 'business', weight: 14 },
  { id: 'b-camind',      label: 'Cámara Industrial', role: 'Sector industrial', cluster: 'business', weight: 16 },
  { id: 'b-emp-portuaria', label: 'Empresas portuarias', role: 'Logística',     cluster: 'business', weight: 18 },

  /* academia — 3 */
  { id: 'aca-rector',    label: 'Rector universidad',    role: 'Académico',          cluster: 'academia', weight: 16 },
  { id: 'aca-think',     label: 'Think tank libertad',   role: 'Centro de estudios', cluster: 'academia', weight: 14 },
  { id: 'aca-cientif',   label: 'Centro estudios local', role: 'Investigación',      cluster: 'academia', weight: 10 },

  /* government — 4 */
  { id: 'g-int-actual',  label: 'Intendente actual',     role: 'Ejecutivo local',  cluster: 'government', weight: 22 },
  { id: 'g-gobernador',  label: 'Gobernador BA',         role: 'Provincia',        cluster: 'government', weight: 24 },
  { id: 'g-min-prod',    label: 'Min. Producción BA',    role: 'Provincial',       cluster: 'government', weight: 14 },
  { id: 'g-senado-ba',   label: 'Senado BA',             role: 'Legislatura',      cluster: 'government', weight: 12 },

  /* religion — 2 */
  { id: 'r-obispado',    label: 'Obispado SN',     role: 'Iglesia católica',  cluster: 'religion', weight: 14 },
  { id: 'r-evangelicos', label: 'Pastor evangélico', role: 'Comunidad evang.', cluster: 'religion', weight: 12 },

  /* influencers — 4 */
  { id: 'i-portuario',   label: '@PortuarioSN',     role: 'Cuenta gremio',     cluster: 'influencers', weight: 14 },
  { id: 'i-movimiento',  label: '@MovimientoSN',    role: 'Activismo UxP',     cluster: 'influencers', weight: 12 },
  { id: 'i-libertad',    label: '@LibertadSN',      role: 'Activismo libertario', cluster: 'influencers', weight: 14 },
  { id: 'i-vecinal',     label: '@VecinalCentro',   role: 'Cuenta barrial',    cluster: 'influencers', weight: 10 },

  /* donors — 3 */
  { id: 'd-anon-1',      label: 'Donante α',        role: 'Empresarial',  cluster: 'donors', weight: 16 },
  { id: 'd-anon-2',      label: 'Donante β',        role: 'Familia local', cluster: 'donors', weight: 14 },
  { id: 'd-pyme',        label: 'PyMEs aportantes', role: 'Aportes mensuales', cluster: 'donors', weight: 10 },
];

export const NETWORK_EDGES = [
  /* equipo: candidato ↔ todos */
  { from: 'fch', to: 'team-jefe', type: 'team' },
  { from: 'fch', to: 'team-comm', type: 'team' },
  { from: 'fch', to: 'team-data', type: 'team' },
  { from: 'fch', to: 'team-terr', type: 'team' },
  { from: 'fch', to: 'team-prensa', type: 'team' },
  { from: 'fch', to: 'team-digital', type: 'team' },
  { from: 'fch', to: 'team-fund', type: 'team' },
  { from: 'fch', to: 'team-legal', type: 'team' },
  /* equipo: relaciones internas */
  { from: 'team-jefe', to: 'team-comm', type: 'team' },
  { from: 'team-jefe', to: 'team-terr', type: 'team' },
  { from: 'team-jefe', to: 'team-fund', type: 'team' },
  { from: 'team-comm', to: 'team-prensa', type: 'team' },
  { from: 'team-comm', to: 'team-digital', type: 'team' },
  { from: 'team-data', to: 'team-comm', type: 'team' },
  { from: 'team-data', to: 'team-digital', type: 'team' },
  { from: 'team-legal', to: 'team-fund', type: 'team' },

  /* aliados */
  { from: 'fch', to: 'lla-nac', type: 'ally' },
  { from: 'fch', to: 'lla-prov', type: 'ally' },
  { from: 'fch', to: 'lla-sn', type: 'ally' },
  { from: 'fch', to: 'concejal-1', type: 'ally' },
  { from: 'fch', to: 'diputada-1', type: 'ally' },
  { from: 'fch', to: 'int-ramallo', type: 'ally' },
  { from: 'fch', to: 'pro-local', type: 'ally' },
  { from: 'lla-nac', to: 'lla-prov', type: 'ally' },
  { from: 'lla-prov', to: 'lla-sn', type: 'ally' },
  { from: 'lla-prov', to: 'diputada-1', type: 'ally' },
  { from: 'lla-sn', to: 'concejal-1', type: 'ally' },

  /* oposición */
  { from: 'fch', to: 'm-passaglia', type: 'opp' },
  { from: 'fch', to: 'comerio', type: 'opp' },
  { from: 'fch', to: 'jxc-sn', type: 'opp' },
  { from: 'fch', to: 'otro-precand', type: 'opp' },
  { from: 'm-passaglia', to: 's-passaglia', type: 'opp' },
  { from: 'comerio', to: 'uxp-prov', type: 'opp' },
  { from: 'uxp-prov', to: 'g-gobernador', type: 'opp' },
  { from: 'm-passaglia', to: 'comerio', type: 'opp' },

  /* medios locales */
  { from: 'fch', to: 'm-norte', type: 'media' },
  { from: 'fch', to: 'm-opinando', type: 'media' },
  { from: 'fch', to: 'm-op-online', type: 'media' },
  { from: 'fch', to: 'm-prensalibre', type: 'media' },
  { from: 'fch', to: 'm-elnuevomundo', type: 'media' },
  { from: 'fch', to: 'm-radioz', type: 'media' },
  { from: 'team-comm', to: 'm-norte', type: 'media' },
  { from: 'team-comm', to: 'm-opinando', type: 'media' },
  { from: 'team-prensa', to: 'm-op-online', type: 'media' },
  { from: 'team-prensa', to: 'm-prensalibre', type: 'media' },
  { from: 'periodista-1', to: 'm-op-online', type: 'media' },
  { from: 'periodista-2', to: 'm-prensalibre', type: 'media' },
  { from: 'periodista-1', to: 'fch', type: 'media' },
  /* prensa nacional */
  { from: 'fch', to: 'p-clarin', type: 'press' },
  { from: 'fch', to: 'p-lanacion', type: 'press' },
  { from: 'team-comm', to: 'p-infobae', type: 'press' },
  { from: 'team-comm', to: 'p-clarin', type: 'press' },
  { from: 'periodista-3', to: 'p-clarin', type: 'press' },
  { from: 'p-pagina12', to: 'comerio', type: 'press' },

  /* sociedad civil */
  { from: 'fch', to: 'civ-camara', type: 'civil' },
  { from: 'fch', to: 'civ-comercio', type: 'civil' },
  { from: 'fch', to: 'civ-vecinal', type: 'civil' },
  { from: 'fch', to: 'civ-foro-edu', type: 'civil' },
  { from: 'team-terr', to: 'civ-vecinal', type: 'civil' },
  { from: 'civ-camara', to: 'b-camind', type: 'civil' },

  /* gremios */
  { from: 'fch', to: 'u-portuario', type: 'union' },
  { from: 'fch', to: 'u-uocra', type: 'union' },
  { from: 'fch', to: 'u-metalurgico', type: 'union' },
  { from: 'u-portuario', to: 'b-emp-portuaria', type: 'union' },
  { from: 'u-uocra', to: 'b-camind', type: 'union' },
  { from: 'u-docente', to: 'civ-foro-edu', type: 'union' },
  { from: 'u-portuario', to: 'team-terr', type: 'union' },

  /* empresariado */
  { from: 'fch', to: 'b-moviport', type: 'business' },
  { from: 'fch', to: 'b-sidersa', type: 'business' },
  { from: 'fch', to: 'b-pymes', type: 'business' },
  { from: 'fch', to: 'b-camind', type: 'business' },
  { from: 'b-moviport', to: 'b-emp-portuaria', type: 'business' },
  { from: 'b-sidersa', to: 'b-camind', type: 'business' },
  { from: 'b-pymes', to: 'civ-comercio', type: 'business' },

  /* academia */
  { from: 'fch', to: 'aca-rector', type: 'academia' },
  { from: 'fch', to: 'aca-think', type: 'academia' },
  { from: 'aca-rector', to: 'aca-cientif', type: 'academia' },
  { from: 'aca-think', to: 'lla-nac', type: 'academia' },

  /* gobierno */
  { from: 'fch', to: 'g-int-actual', type: 'government' },
  { from: 'g-int-actual', to: 'm-passaglia', type: 'government' },
  { from: 'g-gobernador', to: 'g-min-prod', type: 'government' },
  { from: 'g-gobernador', to: 'g-senado-ba', type: 'government' },
  { from: 'diputada-1', to: 'g-senado-ba', type: 'government' },

  /* religión */
  { from: 'fch', to: 'r-obispado', type: 'religion' },
  { from: 'fch', to: 'r-evangelicos', type: 'religion' },
  { from: 'r-obispado', to: 'civ-foro-edu', type: 'religion' },

  /* influencers */
  { from: 'fch', to: 'i-libertad', type: 'influencer' },
  { from: 'i-portuario', to: 'u-portuario', type: 'influencer' },
  { from: 'i-movimiento', to: 'comerio', type: 'influencer' },
  { from: 'i-vecinal', to: 'civ-vecinal', type: 'influencer' },
  { from: 'team-digital', to: 'i-libertad', type: 'influencer' },

  /* donors */
  { from: 'fch', to: 'd-anon-1', type: 'donor' },
  { from: 'fch', to: 'd-anon-2', type: 'donor' },
  { from: 'fch', to: 'd-pyme', type: 'donor' },
  { from: 'team-fund', to: 'd-anon-1', type: 'donor' },
  { from: 'team-fund', to: 'd-anon-2', type: 'donor' },
  { from: 'team-fund', to: 'd-pyme', type: 'donor' },
];

export const EDGE_STYLE = {
  team:        { color: '#06D6A0', label: 'Equipo' },
  ally:        { color: '#FFD166', label: 'Alianza' },
  opp:         { color: '#EF476F', label: 'Oposición' },
  media:       { color: '#A4B0C2', label: 'Medios locales' },
  press:       { color: '#7C8AA0', label: 'Prensa nacional' },
  civil:       { color: '#9CA8B8', label: 'Sociedad civil' },
  union:       { color: '#FFB76A', label: 'Gremios' },
  business:    { color: '#C0B6F0', label: 'Empresariado' },
  academia:    { color: '#86E1E5', label: 'Academia' },
  government:  { color: '#FF9FB1', label: 'Gobierno' },
  religion:    { color: '#D9C9A3', label: 'Religiosos' },
  influencer:  { color: '#7BC4FF', label: 'Influencers' },
  donor:       { color: '#FFD78B', label: 'Mecenas' },
};

/* ============================================================
   Layout: 0° = arriba (12 o'clock), avanza en sentido horario.
   Dos anillos exteriores intercalados (mid r=27 / far r=43) para
   que clusters adyacentes no se pisen. team va en el inner (r=13).
   Arcos calibrados con gap de 2° entre clusters → suma 360°.
   ============================================================ */

const RING_R = { core: 0, inner: 13, mid: 27, far: 43 };

// Orden y arco (en grados, 0=arriba, horario). Ring alterna mid↔far para
// que vecinos en el círculo no compartan radio.
const CLUSTER_DEF = {
  core:        { ring: 'core',  arc: [0, 0] },
  team:        { ring: 'inner', arc: [0, 360] },     // rodea al candidato

  allies:      { ring: 'mid',   arc: [338, 22] },    // top — straddles 0°
  academia:    { ring: 'far',   arc: [24, 43] },
  government:  { ring: 'mid',   arc: [45, 70] },
  opp:         { ring: 'far',   arc: [72, 109] },
  press:       { ring: 'mid',   arc: [111, 136] },
  media:       { ring: 'far',   arc: [138, 185] },   // largo (8 nodos)
  influencers: { ring: 'mid',   arc: [187, 212] },
  civil:       { ring: 'far',   arc: [214, 239] },
  religion:    { ring: 'mid',   arc: [241, 255] },
  union:       { ring: 'far',   arc: [257, 282] },
  business:    { ring: 'mid',   arc: [284, 315] },
  donors:      { ring: 'far',   arc: [317, 336] },
};

function angleOf(idx, count, [start, end]) {
  let span = end - start;
  if (span < 0) span += 360;            // soporta wrap (allies)
  if (count <= 1) {
    return ((start + span / 2) % 360 + 360) % 360;
  }
  const pad = Math.min(span * 0.08, 5); // padding interior
  const usable = Math.max(0.001, span - pad * 2);
  const step = usable / (count - 1);
  return ((start + pad + idx * step) % 360 + 360) % 360;
}

// 0° = arriba (12 o'clock). En SVG, x = cx + r*sin(rad), y = cy - r*cos(rad).
function project(cx, cy, r, deg) {
  const rad = (deg * Math.PI) / 180;
  return [cx + r * Math.sin(rad), cy - r * Math.cos(rad)];
}

export function computeNetworkLayout(nodes) {
  const cx = 50, cy = 50;
  const byCluster = {};
  for (const n of nodes) (byCluster[n.cluster] ||= []).push(n);

  const out = [];
  for (const cluster of Object.keys(byCluster)) {
    const def = CLUSTER_DEF[cluster];
    const list = byCluster[cluster];
    if (!def) {
      list.forEach((n) => out.push({ ...n, x: cx, y: cy }));
      continue;
    }
    if (cluster === 'core') {
      list.forEach((n) => out.push({ ...n, x: cx, y: cy }));
      continue;
    }
    const r = RING_R[def.ring];
    list.forEach((n, i) => {
      const a = angleOf(i, list.length, def.arc);
      const [x, y] = project(cx, cy, r, a);
      const meta = CLUSTER_META[cluster] || {};
      out.push({
        ...n,
        x: Math.max(5, Math.min(95, x)),
        y: Math.max(7, Math.min(93, y)),
        color: n.color || meta.color,
      });
    });
  }
  return out;
}

/* exporta una versión pre-calculada para uso directo */
export const NETWORK_NODES_LAID = computeNetworkLayout(NETWORK_NODES);
